import { useI18n } from "../i18n/I18nProvider";
import { Lock, X, Mail, LogIn } from "lucide-react";

const CONTACT_EMAIL = "info@resourcebuild.se";

export default function LockedModuleModal({ onClose, onLogin }) {
  const { t } = useI18n();

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm grid place-items-center p-4"
      onClick={onClose}
      data-testid="locked-module-modal"
    >
      <div
        className="bg-[var(--bone)] border border-[var(--ink-200)] max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between px-5 py-4 border-b border-[var(--ink-200)]">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[var(--ink)] text-[var(--bone)] grid place-items-center shrink-0">
              <Lock size={16} />
            </div>
            <div>
              <div className="font-display text-lg tracking-tight">{t("locked.modal.title")}</div>
              <div className="label-tech mt-0.5">ReSource Hybrid · Organisation</div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-[var(--surface-alt)]"
            data-testid="locked-modal-close"
            aria-label="Close"
          >
            <X size={16} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <p className="text-sm text-[var(--ink-700)] leading-relaxed" data-testid="locked-modal-text">
            {t("locked.modal.text")}
          </p>

          <div className="border-l-2 border-[var(--moss)] bg-[var(--surface-alt)] px-3 py-2.5 text-xs text-[var(--ink-700)]">
            {t("locked.modal.hint")}
          </div>
        </div>

        <div className="px-5 py-4 border-t border-[var(--ink-200)] flex flex-wrap items-center justify-end gap-2">
          <button
            onClick={onClose}
            className="btn-ghost"
            data-testid="locked-modal-dismiss"
          >
            {t("locked.modal.later")}
          </button>
          <button
            onClick={onLogin}
            className="btn-ghost"
            data-testid="locked-modal-login"
          >
            <LogIn size={14} /> {t("nav.signIn")}
          </button>
          <a
            href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(t("locked.modal.title"))}`}
            className="btn-primary"
            data-testid="locked-modal-contact"
          >
            <Mail size={14} /> {t("locked.modal.button")}
          </a>
        </div>
      </div>
    </div>
  );
}
